export const CASH_SETTLEMENT_QUOTATION = [
  { id: 'BID', displayValue: 'Bid' },
  { id: 'OFFER', displayValue: 'Offer' },
  { id: 'MID_MARKET', displayValue: 'Mid-Market' },
  { id: 'NOT_APPLICABLE', displayValue: 'Not Applicable' },
];
